import {
  Avatar,
  Button,
  Dropdown,
  Message,
  Popconfirm,
  Tag,
  Tooltip,
} from '@arco-design/web-react';
import { ColumnProps } from '@arco-design/web-react/es/Table';
import { IconCopy, IconDown, IconUser } from '@arco-design/web-react/icon';
import dayjs from 'dayjs';
import ClientTabs from '@/mobx/modules/tabStore';
import { v4 as uuidv4 } from 'uuid';
import copy from 'copy-to-clipboard';
import { appStore, userStore } from '@/mobx';

// 授权状态映射
export const AuthStatusMap = {
  '-1': <Tag color="gray">未授权</Tag>,
  1: <Tag color="green">已授权</Tag>,
  2: <Tag color="red">失效</Tag>,
};
export const addTab = (row, tabItem) => {
  if (window.electron) {
    console.log(
      'addTab',
      row,
      ClientTabs.tabs,
      ClientTabs.tabs.findIndex((v) => v.key == row.webview_id)
    );
    // if (client_id === record.client_id) {

    if (
      row.webview_id &&
      ClientTabs.tabs.findIndex((v) => v.key == row.webview_id) !== -1
    ) {
      ClientTabs.setActivePath(row.webview_id);
      return;
    }

    const key = row?.webview_id || uuidv4();
    console.log('key', key);
    ClientTabs.addTab({
      title: tabItem.name + '-' + (row.remark ?? ''),
      path: '/' + tabItem.key,
      key,
      src: tabItem.meta?.webviewUrl,
      icon: '',
      platform: tabItem.meta?.platform || '',
      isFinite: false,
      content: `<div id="${key}" style="height: 100%; display: block;"></div>`,
      data: {
        cookie: row.auth_data || '',
        aid: appStore.aid,
        account_id: row.id,
        team_id: userStore.currentTeam?.id,
        auth_status: row.auth_status,
      },
    });
  }
};

// 表格列配置
export const tableColumns = (
  remark: ColumnProps<any>,
  tabItem: Record<string, any>
  // publish: ColumnProps<any>
): ColumnProps<any>[] => [
  {
    dataIndex: 'xh',
    title: '序号',
    width: 60,
    fixed: 'left',
    render: (text, row, index) => index + 1,
  },
  remark,
  ...((Number(appStore.platformId) !== 12
    ? [
        {
          dataIndex: 'acount',
          title: '账密信息',
          width: 180,
          render: (col, row) => (
            <div style={{ color: '#333' }}>
              <Tooltip
                content={
                  <div>
                    {row.account}{' '}
                    <IconCopy
                      style={{ cursor: 'pointer', fontSize: 16 }}
                      onClick={() => {
                        copy(row.account);
                        Message.success('账号已复制');
                      }}
                    />{' '}
                  </div>
                }
              >
                <div className="ellipsis">账号：{row.account}</div>
              </Tooltip>
              <Tooltip
                content={
                  <div>
                    {row.password}{' '}
                    <IconCopy
                      style={{ cursor: 'pointer', fontSize: 16 }}
                      onClick={() => {
                        copy(row.password);
                        Message.success('密码已复制');
                      }}
                    />{' '}
                  </div>
                }
              >
                密码：{row.password}
              </Tooltip>
            </div>
          ),
        },
      ]
    : []) as ColumnProps<any>[]),
  {
    dataIndex: 'mock2',
    title: '账号信息',
    width: 220,
    render: (col, row) =>
      row.auth_status !== -1 ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            cursor: 'pointer',
          }}
          onClick={() => {
            addTab(row, tabItem);
          }}
        >
          <Avatar size={34}>
            {row.avatar && ![9, 10].includes(row.platform_id) ? (
              <img src={row.avatar || ''} />
            ) : (
              <IconUser style={{ color: '#eee', fontSize: 16 }} />
            )}
          </Avatar>
          <div style={{ flex: 1 }}>
            {row.nickname}
            <div style={{ color: '#999', fontSize: 12 }}>ID: {row.id}</div>
          </div>
        </div>
      ) : (
        '-'
      ),
  },
  {
    dataIndex: 'auth_status',
    title: '授权状态',
    align: 'center',
    width: 110,
    render: (col, row) => (
      <span
        style={{ cursor: 'pointer' }}
        onClick={() => {
          addTab(row, tabItem);
        }}
      >
        {AuthStatusMap[row.auth_status]}
      </span>
    ),
  },
  ...((Number(appStore.platformId) === 12
    ? [
        {
          dataIndex: 'douyin_publish_type',
          title: '发布方式',
          align: 'center',
          width: 100,
          render: (col, row) => (
            <Tag color={row.douyin_publish_type === 1 ? 'blue' : 'green'}>
              {row.douyin_publish_type === 1 ? '服务端' : '小助手'}
            </Tag>
          ),
        },
      ]
    : []) as ColumnProps<any>[]),
  {
    dataIndex: 'publish_count',
    title: '文章发布数',
    align: 'center',
    width: 120,
    render: (text) => text || 0,
  },
  {
    dataIndex: 'created_at',
    title: '创建时间',
    width: 160,
    render: (text) =>
      text ? dayjs.unix(text).format('YYYY-MM-DD HH:mm:ss') : '-',
  },
  {
    dataIndex: 'updated_at',
    title: '更新时间',
    width: 160,
    render: (text) =>
      text ? dayjs.unix(text).format('YYYY-MM-DD HH:mm:ss') : '-',
  },
];
// 操作按钮
const optionKeys: Record<string, string> = {
  edit: '编辑',
  delete: '删除',
  after: '官方后台',
};
export const optionBtn = (keys: string[], onClick: (key: string) => void) => {
  if (!keys || !keys.length) return null;
  if (keys.length > 2) {
    return (
      <Dropdown
        droplist={
          <div className="header_popover_content">
            {keys.map((item) => (
              <div key={item} className="header_popover_item">
                {item === 'delete' ? (
                  <Popconfirm
                    key="confirm"
                    focusLock
                    title="提示"
                    content="确定删除该账号吗？"
                    onOk={() => {
                      onClick(item);
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        height: 32,
                        textAlign: 'center',
                        lineHeight: '32px',
                      }}
                    >
                      {optionKeys[item] || ''}
                    </div>
                  </Popconfirm>
                ) : (
                  <div
                    key={item}
                    style={{
                      width: '100%',
                      height: 32,
                      textAlign: 'center',
                      lineHeight: '32px',
                    }}
                    onClick={() => onClick(item)}
                  >
                    {optionKeys[item] || ''}
                  </div>
                )}
              </div>
            ))}
          </div>
        }
        position="bl"
      >
        <Button type="text" size="small">
          更多 <IconDown />
        </Button>
      </Dropdown>
    );
  }
  return keys.map((item) => (
    <Button key={item} type="text" size="small" onClick={() => onClick(item)}>
      {optionKeys[item] || ''}
    </Button>
  ));
};
